import {createPlanetTheme} from '@apps-common/ui-theme/Themes.js';

import {componentOverrides} from './overrides.js';

export const theme = createPlanetTheme({
  colorScheme: 'light',
  extendedConfig: {
    components: componentOverrides,
  },
});
